import { defineMessages, type MessageDescriptor } from 'react-intl';

export const messages: Record<'label' | 'showMore', MessageDescriptor> = defineMessages({
	label: {
		id: 'company-hub-common.hub-breadcrumbs.label.non-final',
		defaultMessage: 'Breadcrumbs',
		description: 'Accessible label for the breadcrumb navigation shown on Help Hub pages.',
	},
	showMore: {
		id: 'company-hub-common.hub-breadcrumbs.showMore.non-final',
		defaultMessage: 'Show more breadcrumbs',
		description:
			'Accessible label for the button that reveals breadcrumb items hidden at narrow widths.',
	},
});
